module.exports = __webpack_public_path__ + "media/DF_homepage_video.ef718a1a.mp4";